<template>
  <div class="cadastro container is-fluid fullwidth">
    <form v-on:submit.prevent="editarCadastrar">
      <b-card bg-variant="light">
        <b-form-group
          label-cols-lg="3"
          label="Esposo"
          label-size="lg"
          label-class="font-weight-bold pt-0"
          class="mb-0">

          <b-form-group label="Apelido">
            <b-form-input v-model="casal.esposo.apelido" trim></b-form-input>
          </b-form-group>
          <b-form-group label="Nome">
            <b-form-input v-model="casal.esposo.nome" trim required :state="validarNomeEsposo">
            </b-form-input>
          </b-form-group>
          <b-form-group
            label="Aniversário">
            <b-form-input v-model="casal.esposo.aniversario" type="date"></b-form-input>
          </b-form-group>
          <b-form-group
            label="Telefone">
            <input class="form-control" type="text" v-mask="'(##) #####-####'"
              masked="false" v-model="casal.esposo.telefone">
          </b-form-group>
          <b-form-group
            label="E-mail">
            <b-form-input v-model="casal.esposo.email" trim></b-form-input>
          </b-form-group>

        </b-form-group>
      </b-card>
      <br>
      <b-card bg-variant="light">
        <b-form-group
          label-cols-lg="3"
          label="Esposa"
          label-size="lg"
          label-class="font-weight-bold pt-0"
          class="mb-0">

          <b-form-group label="Apelido">
            <b-form-input v-model="casal.esposa.apelido" trim></b-form-input>
          </b-form-group>
          <b-form-group label="Nome">
            <b-form-input v-model="casal.esposa.nome" trim required
              :state="validarAnversarioEsposa"></b-form-input>
          </b-form-group>
          <b-form-group
            label="Aniversário">
            <b-form-input v-model="casal.esposa.aniversario" type="date"></b-form-input>
          </b-form-group>
          <b-form-group
            label="Telefone">
            <input class="form-control" type="text" v-mask="'(##) #####-####'"
              masked="false" v-model="casal.esposa.telefone">
          </b-form-group>
          <b-form-group
            label="E-mail">
            <b-form-input v-model="casal.esposa.email" trim></b-form-input>
          </b-form-group>

        </b-form-group>
      </b-card>
      <br>
      <b-card bg-variant="light">
        <b-form-group
          label-cols-lg="3"
          label="Casal"
          label-size="lg"
          label-class="font-weight-bold pt-0"
          class="mb-0">

          <b-form-group label="Endereço">
            <b-form-input v-model="casal.endereco" trim></b-form-input>
          </b-form-group>
          <b-form-group label="Data Casamento">
            <b-form-input v-model="casal.casamento" type="date"></b-form-input>
          </b-form-group>
          <b-form-group label="ECC">
            <b-form-select v-model="casal.ecc" :options="eccOptions" :state="validarEcc"></b-form-select>
          </b-form-group>
          <b-form-group label="Círculo">
            <b-form-input v-model="casal.circulo" trim :state="validarCirculo"></b-form-input>
          </b-form-group>
          <b-form-group label="Observações">
            <b-form-textarea v-model="casal.observacao"
              placeholder=""
              rows="3"
              max-rows="3"
            ></b-form-textarea>
          </b-form-group>
          <b-form-checkbox v-model="casal.coordenador" value="true" unchecked-value="false">
            Coordenadores</b-form-checkbox>
        </b-form-group>
      </b-card>
      <hr>
      <b-button variant="outline-primary" type="submit" class="button">{{buttonLabel}}</b-button>
    </form>
  </div>
</template>
<script>
import { mask } from 'vue-the-mask';
import { db } from '../../main';

export default {
  name: 'Cadastro-Casal',
  data() {
    return {
      eccOptions: [
        { value: null, text: 'Selecione uma opção' },
        { value: 1, text: '1º ECC' },
        { value: 2, text: '2º ECC' },
        { value: 3, text: '3º ECC' },
        { value: 4, text: '4º ECC' },
        { value: 5, text: '5º ECC' },
      ],
      casal: {
        esposo: {
          nome: '',
          aniversario: null,
          apelido: '',
          telefone: '',
          email: '',
          mesAniversario: '',
        },
        esposa: {
          nome: '',
          aniversario: null,
          apelido: '',
          telefone: '',
          email: '',
          mesAniversario: '',
        },
        endereco: '',
        casamento: null,
        mesCasamento: '',
        observacao: '',
        coordenador: false,
        circulo: '',
        ecc: null,
      },
      buttonLabel: 'Cadastrar',
      edit: false,
    };
  },
  directives: {
    mask,
  },
  computed: {
    validarNomeEsposo() {
      return this.casal.esposo.nome.length > 4;
    },
    validarAnversarioEsposa() {
      return this.casal.esposa.nome.length > 4;
    },
    validarCirculo() {
      return this.casal.circulo.length > 4;
    },
    validarEcc() {
      return this.casal.ecc != null || this.casal.ecc != undefined;
    }
  },
  methods: {
    editarCadastrar() {
      this.atualizarMes();
      if (this.edit) {
        this.editar();
      } else {
        this.cadastrar();
      }
    },
    editar() {
      db.collection('casais')
        .doc(this.$route.params.id)
        .set(this.casal)
        .then(() => {
            this.init();
            window.scrollTo(0, 0);
        });
    },
    cadastrar() {
      db.collection('casais').add(this.casal).then((doc) => {
        if (doc) {
          this.init();
          this.$router.push({name: 'lista_casal'});
        }
      });
    },
    atualizarMes() {
      if (isNaN(this.casal.esposo.aniversario)) {
        this.casal.esposo.mesAniversario = new Date(this.casal.esposo.aniversario).getMonth() + 1;
      }
      if (isNaN(this.casal.esposa.aniversario)) {
        this.casal.esposa.mesAniversario = new Date(this.casal.esposa.aniversario).getMonth() + 1;
      }
      if (isNaN(this.casal.casamento) && this.casal.casamento !== undefined) {
        this.casal.mesCasamento = new Date(this.casal.casamento).getMonth() + 1;
      }
    },
    init() {
      this.casal = {
        esposo: {
          nome: '',
          aniversario: null,
          apelido: '',
          telefone: '',
          email: '',
        },
        esposa: {
          nome: '',
          aniversario: null,
          apelido: '',
          telefone: '',
          email: '',
        },
        endereco: '',
        casamento: null,
        observacao: '',
        coordenador: false,
        circulo: '',
      };
    },
  },
  mounted() {
    if (this.$route.params.id) {
      db.collection('casais').doc(this.$route.params.id).get().then((doc) => {
        this.casal = doc.data();
        this.$store.commit('setLoading', false);
      });
      this.buttonLabel = 'Editar';
      this.edit = true;
    } else {
      this.$store.commit('setLoading', false);
    }
  },
  beforeCreate() { },
};
</script>
